import { NgModule } from '@angular/core';
import { DropdownComponent } from './dropdown.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [DropdownComponent],
  exports: [DropdownComponent],
  imports: [BrowserModule, BrowserAnimationsModule, FormsModule, TranslateModule],
  providers: []
})
export class DropdownModule {}



// WEBPACK FOOTER //
// ./src/app/modules/dropdown/dropdown.module.ts